<template>
  <div>
    <div class="ts-flex ts-justify-between">
      <div class="ts-flex ts-space-x-3">
        <!-- keep this section in msk -->
        <ts-checkbox v-model="model.is_dealer_price" @change="onDealerPriceChange">
          {{ $t('borrowingSparePart.dealerPrice') }}
        </ts-checkbox>
        <!-- end section -->
        <a href="#"
          class="ts-shadow-rounded ts-uppercase ts-px-4 ts-rounded-md ts-bg-blue-400 ts-text-white ts-flex ts-items-center ts-no-underline hover:ts-no-underline"
          style="height: 31px" @click.prevent="getProductBalance">
          <span class="ts-mr-2">{{ $t('saleContract.getBalance') }}</span>
          <i class="fas fa-balance-scale"></i>
        </a>
      </div>
      <div class="ts-space-x-3 ts-flex ts-uppercase">
        <h6>
          <span>{{ $t('borrowingSparePart.fxusdRate') }}:
            {{ UsdRate }} $</span>
        </h6>
        <h6>
          <span>{{ $t('borrowingSparePart.fxRateKh') }}:
            {{ khrRate }} ៛</span>
        </h6>
        <!-- keep this section in msk -->
        <h6>
          <a href="#" @click.prevent="onMachineryClick">
            <span class="ts-text-blue-600">{{ $t('borrowingSparePart.machinery') }}:
            </span>
            {{ model.product_name }}
          </a>
        </h6>
        <h6>
          <a href="#" @click.prevent="$emit('showSerial')">
            <span class="ts-text-blue-600">{{ $t('borrowingSparePart.engineNumber') }}:
            </span>
            {{ model.engine_number }}
          </a>
        </h6>
        <!-- end section -->
      </div>
    </div>
    <table class="ts-w-full ts-mt-3">
      <thead>
        <tr class="ts-bg-gray-200 ts-border-b">
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-3">
            {{ $t('borrowingSparePart.no') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24" style="width: 150px;">
            {{ $t('borrowingSparePart.serviceDate') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.barcode') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase">
            {{ $t('borrowingSparePart.product') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.endingBalance') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-24">
            {{ $t('borrowingSparePart.uom') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-32 ts-text-center">
            {{ $t('borrowingSparePart.qtyOrder') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-w-40 ts-text-right">
            {{ $t('borrowingSparePart.unitPrice') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-text-center ts-w-32">
            {{ $t('borrowingSparePart.discount') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-uppercase ts-text-right ts-w-48">
            {{ $t('borrowingSparePart.amount') }}
          </th>
          <th class="ts-px-3 ts-py-2 ts-w-2">
            <a href="#" @click.prevent="() => (visible = true)"><i class="fas fa-plus"></i></a>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="ts-border-b" v-for="(p, index) in model.product_detail" :key="index">
          <td class="ts-px-3 ts-py-2">{{ index + 1 }}</td>
          <td class="ts-px-3" style="width: 150px;">
            <div class="detail">
              <a-date-picker v-model="p.service_date" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY" class="ts-w-full"
                :disabled="(!p.sfo_id ? false : true)" :disabled-date="disabledDate"></a-date-picker>
            </div>
          </td>
          <td class="ts-px-3 ts-py-2">{{ p.barcode }}</td>
          <td class="ts-px-3 ts-py-2">{{ p.product_name }}</td>
          <td class="ts-px-3 ts-py-2 ts-text-center">{{ p.ending_balance }}</td>
          <td class="ts-px-3 ts-py-2">
            <select class="ts-w-full ts-outline-none" v-model="p.uom_id" @change="onUomChange(p)">
              <option v-for="(u, index) in getUomList(p.product_id)" :key="index" :value="u.uom_id">
                {{ u.uom_name_kh }}
              </option>
            </select>
            <div class="validate" v-if="errors.has('product_detail.' + index + '.uom_id')">
              {{ errors.first('product_detail.' + index + '.uom_id') }}
            </div>
          </td>
          <td class="ts-px-3 ts-py-2">
            <input v-model.number="p.quantity_order" type="number" value="3"
              class="ts-w-full ts-text-center ts-border ts-rounded ts-py-1" @input="calculate"
              :disabled="disabledUpdate(p)" />
            <div class="validate" v-if="errors.has('product_detail.' + index + '.quantity_order')">
              {{ errors.first('product_detail.' + index + '.quantity_order') }}
            </div>
          </td>
          <td class="ts-px-3 ts-py-2">
            <ts-currency-input currency="฿" type="text" :value="p.sale_price"
              class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2" disabled />
          </td>
          <td class="ts-px-3 ts-py-2">
            <input v-model.number="p.discount_rate" type="number"
              class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-center ts-px-2" @input="calculate"
              :disabled="disabledUpdate(p)" />
            <div class="ts-text-red-500" v-if="errors.has('product_detail.' + index + '.discount_rate')">
              {{ errors.first('product_detail.' + index + '.discount_rate') }}
            </div>
          </td>
          <td class="ts-px-3 ts-py-2">
            <ts-currency-input currency="฿" type="text" :value="amountAfterDiscount(p)"
              class="ts-w-full ts-border ts-rounded ts-py-1 ts-text-right ts-px-2" disabled />
          </td>
          <td class="ts-px-3 ts-py-2 ts-text-center">
            <a v-if="!disabledUpdate(p)" href="#" class="ts-text-red-600 ts-my-auto"
              @click.prevent="removeRow(p, index)">
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="ts-w">
          <td class="ts-text-red-700 ts-text-right ts-px-3 ts-py-2" colspan="6">
            {{ $t('borrowingSparePart.total') + ': ' }}
          </td>
          <td class="ts-text-red-700 ts-text-center ts-px-3 ts-pr-6 ts-py-2">
            {{ $formatNumber(qty) }}
          </td>
          <td class="ts-text-red-700 ts-text-right ts-px-3 ts-py-2">
            <!-- <p class="ts-font-extrabold">{{ $currencyFormat(sumCost) }}</p> -->
          </td>
          <td class="ts-text-red-700 ts-text-right ts-px-3 ts-py-2">
            <!-- <p class="ts-font-extrabold">{{ $currencyFormat(sumCost) }}</p> -->
          </td>
          <td class="ts-text-red-700 ts-text-right ts-px-3 ts-py-2 ts-pr-5">
            {{ '฿ ' + $formatNumber(amount, 2) }}
          </td>
        </tr>
      </tfoot>
    </table>

    <!-- search product  -->
    <a-modal v-model="visible" :title="$t('borrowingSparePart.productList')" :footer="null" width="600px">
      <ts-loading-banner :loading="searching">
        <div class="ts-flex">
          <div class="ts-relative ts-w-full">
            <input v-model.trim="searchValue" ref="search" type="text"
              class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
              :placeholder="$t('borrowingSparePart.searchProduct')" />
            <span class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2" style="margin-top: 7px">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
        <div class="container-table ts-mt-3 ts-border ts-border-gray-300 ts-p-3 ts-rounded max-h">
          <table class="ts-w-full">
            <thead>
              <tr>
                <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                  {{ $t('borrowingSparePart.barcode') }}
                </th>
                <th class="ts-bg-gray-200 ts-px-2 ts-py-1">
                  {{ $t('borrowingSparePart.product') }}
                </th>
                <th class="ts-bg-gray-200 ts-px-2 ts-py-1 ts-text-center">
                  {{ $t('borrowingSparePart.qty') }}
                </th>
                <th class="ts-bg-gray-200 ts-px-1 ts-py-1 ts-text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(p, index) in productFromServer" :key="index" class="ts-cursor-pointer hover:ts-bg-gray-300">
                <td @click="onAddProduct(p)" class="ts-whitespace-no-wrap ts-py-1">
                  {{ p.barcode }}
                </td>
                <td @click="onAddProduct(p)" class="ts-pl-1 ts-py-1">
                  {{ p.product_name_kh }}
                </td>
                <td class="ts-pl-1 ts-whitespace-no-wrap">
                  <input type="number" class="form-control" v-model.number="p.qty" @keypress.enter="onAddProduct(p)" />
                </td>
                <td class="ts-px-3 ts-whitespace-no-wrap">
                  <a href="#" class="ts-text-blue-500" @click.prevent="onAddProduct(p)">
                    <i class="fa fa-plus"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <small><i>{{ $t('borrowingSparePart.clickToAddProduct') }}</i></small>
      </ts-loading-banner>
    </a-modal>

    <!-- show machinery -->
    <a-modal v-model="show_machinery" :title="$t('borrowingSparePart.machinery')" :footer="null" width="350px">
      <ts-loading-banner :loading="main_product_searching">
        <div class="ts-w-full ts-space-y-3">
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('borrowingSparePart.product')
              }}</label>
              <a-select show-search v-model="model.product_id" :placeholder="$t('borrowingSparePart.searchProduct')"
                style="width: 300px" :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                :not-found-content="null" @search="handleSearch" @change="mainProductChange">
                <a-select-option v-for="p in productList" :key="p.product_id">
                  {{ p.product_name_kh }}
                </a-select-option>
              </a-select>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <label class="ts-text-xs">{{
                $t('borrowingSparePart.engineNumber')
              }}</label>
              <input v-model="engine_number" type="text" class="form-control"
                :class="{ 'is-invalid': errors.has('engine_number') }" @input="inputEngine" />
              <div class="invalid-feedback ts-text-xs" v-if="errors.has('engine_number')">
                {{ errors.first('engine_number') }}
              </div>
            </div>
          </div>
        </div>
      </ts-loading-banner>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { isEmpty, debounce, sumBy } from 'lodash'
import { Errors } from 'form-backend-validation'
import moment from 'moment'

export default {
  props: ['value'],
  data() {
    return {
      errors: new Errors(),
      searchValue: null,
      visible: false,
      show_machinery: false,
      main_product_searching: false,
      searching: false,
      engine_number: null,
      amount: 0,
      qty: 0,
      model: {},
      tempDetails: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    ...mapState('wholesale/borrowingSparePart', ['formModels', 'edit_data']),
    productFromServer() {
      if (!this.formModels.product) return []
      return this.formModels.product
      // return this.formModels.product.filter(
      //   p =>
      //     !includes(
      //       this.tempDetails.map(el => el.product_id),
      //       p.product_id
      //     )
      // )
    },
    getUomList: vm => productId => {
      let uomList = vm.tempDetails.find(d => d.product_id == productId)
      return uomList ? uomList.unit_of_measures : []
    },
    productList() {
      return this.formModels.mainProduct
    },
    khrRate() {
      if (this.formModels.exchangeRate) {
        let foundFx = this.formModels.exchangeRate.find(e => e.to_currency == 'KHR')

        if (foundFx) {
          return this.model.fx_rate_kh = parseFloat(foundFx.fx_rate)
        }
      }
      return (this.model.fx_rate_kh = 123)
    },
    UsdRate() {
      if (this.formModels.exchangeRate) {
        let foundFx = this.formModels.exchangeRate.find(e => e.to_currency == 'USD')

        if (foundFx) {
          return this.model.fx_rate_thb = parseFloat(foundFx.fx_rate)
        }
      }
      return (this.model.fx_rate_thb =  0.03077)
    }
  },
  methods: {
    ...mapActions('wholesale/borrowingSparePart', [
      'getFormViewData',
      'productBalance'
    ]),
    disabledUpdate(detail) {
      if (!detail.sfo_id) {
        return false
      } else {
        if (detail.service_date == moment().format('DD-MM-YYYY')) {
          return false
        }
        return true
      }
    },
    disabledDate(current) {
      return current && current < moment().startOf('day');
    },
    async onProductSearch() {
      this.searching = true
      await this.getFormViewData({
        index: 'product',
        params: {
          fnName: 'product',
          search: this.searchValue
        }
      })
      this.searching = false
    },
    onAddProduct(product) {
      let uomId = product.unit_of_measures.find(u => u.is_default).uom_id
      let price = product.sale_code.find(p => p.uom_id == uomId)
      this.model.product_detail.push({
        product_id: product.product_id,
        barcode: product.barcode,
        product_name: product.product_name_kh,
        uom_id: uomId,
        quantity_order: product.qty ? product.qty : 1,
        sale_price: this.model.is_dealer_price
          ? price.dealer_price
          : price.sale_price,
        vendor_standard_price: price.vendor_standard_price,
        discount_rate: 0,
        amount: price.sale_price * 1,
        ending_balance: 'N/A',
        remarks: null,
        sfo_id: null,
        service_date: moment().format('DD-MM-YYYY')
      })
      this.tempDetails.push(product)
    },
    removeRow(p, index) {
      this.model.product_detail.splice(index, 1)
      this.tempDetails.splice(this.tempDetails.indexOf(p.product_id), 1)
    },
    onUomChange(product) {
      let saleCode = this.tempDetails.find(
        t => t.product_id == product.product_id
      )
      let price = saleCode.find(s => s.uom_id == product.uom_id)
      product.sale_price = this.model.is_dealer_price
        ? price.dealer_price
        : price.sale_price
      this.calculate()
    },
    onDealerPriceChange() {
      this.model.product_detail.forEach(el => {
        let product = this.tempDetails.find(t => t.product_id == el.product_id)
        let price = product.sale_code.find(s => s.uom_id == el.uom_id)
        el.sale_price = this.model.is_dealer_price
          ? price.dealer_price
          : price.sale_price

        var calculatePrice = el.sale_price * el.quantity_order
        var discount_amount = (calculatePrice * el.discount_rate) / 100
        el.amount = calculatePrice - discount_amount
      })
    },
    calculate() {
      this.model.product_detail.forEach(el => {
        var price = el.sale_price * el.quantity_order
        var discount_amount = (price * el.discount_rate) / 100
        el.amount = price - discount_amount
      })
    },
    onMachineryClick: debounce(async function () {
      this.show_machinery = true
      if (this.model.product_id) {
        this.main_product_searching = true
        await this.getFormViewData({
          index: 'mainProduct',
          params: {
            product_id: this.model.product_id
          }
        })
      }
      this.main_product_searching = false
    }, 800),
    handleSearch: debounce(async function (value) {
      this.main_product_searching = true
      await this.getFormViewData({
        index: 'mainProduct',
        params: {
          fnName: 'mainProduct',
          search_product: value
        }
      })
      this.main_product_searching = false
    }, 800),
    mainProductChange(value) {
      this.model.product_name = this.productList.find(
        p => p.product_id == value
      ).product_name_kh
    },
    inputEngine() {
      this.model.engine_number = this.engine_number
    },
    amountTotal() {
      this.amount =
        sumBy(this.model.product_detail, function (o) {
          let amount_price = o.sale_price * o.quantity_order
          let discount_amount = amount_price * o.discount_rate / 100
          return amount_price - discount_amount
        })
    },
    sumTotalQty() {
      this.qty = sumBy(this.model.product_detail, 'quantity_order')
    },
    amountAfterDiscount(product) {
      let total_amount = product.sale_price * product.quantity_order
      let discount_amount = total_amount * product.discount_rate / 100
      return total_amount - discount_amount
    },
    checkPromotion() {
      if (this.formModels.promotions) {
        this.model.product_detail.map(product => {
          let incentive_by_item = this.formModels.promotions.incentive_by_item.length > 0 ? this.formModels.promotions.incentive_by_item.find(el => el.product_id == product.product_id) : null
          if (incentive_by_item) {
            product.discount_rate = incentive_by_item.discount_rate
          }
        })
      }
      this.calculate()
    },
    getProductBalance() {
      // this.$emit('loading', true)
      var product = this.model.product_detail.map(el => el.product_id)
      if (product.length) {
        this.$emit('loading', true)
        this.productBalance({
          product_id: product
        })
          .then(response => {
            let data = response.data
            this.model.product_detail.forEach(
              el =>
              (el.ending_balance = data.find(
                p => p.product_id == el.product_id
              ).ending_balance)
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.$emit('loading', false)
          })
      }
    }
  },
  watch: {
    'model.service_date': function (value) {
      if (isEmpty(this.edit_data)) {
        this.model.product_detail.map(el => {
          el.service_date = value
        })
      }
    },
    'model.product_detail': {
      handler() {
        this.checkPromotion()
        this.amountTotal()
        this.sumTotalQty()
      },
      deep: true
    },
    searchValue: debounce(function () {
      this.onProductSearch()
    }, 800),
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style scoped>
.container-table {
  min-height: 400px;
  max-height: 450px;
  overflow-y: scroll;
}
</style>

<style>
.detail .ant-calendar-picker-input {
  height: 28px !important;
}
</style>